import { action, observable } from "mobx";
import BaseStore from "./BaseStore";

class Store extends BaseStore {
  @observable loadingInputSearch: boolean = false;

  constructor() {
    super("CommonStore");
  }

  pushSortingByField(array, item, field, compare): void {
    let index = -1;
    if (typeof field === "string")
      index = array.findIndex((itm) => compare(itm[field], item[field]));
    else if (typeof field === "object") {
      let getField = (tm) => {
          for (let key of field) {
            if (tm[key]) tm = tm[key];
            else return false;
          }
          return tm;
        },
        fieldItem = getField(item);
      if (fieldItem === false) index = 0;
      else index = array.findIndex((itm) => compare(getField(itm), fieldItem));
    }
    if (index === -1) array.push(item);
    else array.splice(index, 0, item);
  }
}

let CommonStore = new Store();

export { CommonStore };



// WEBPACK FOOTER //
// ./src/common/CommonStore.ts